<template>
    <div class="w100">
        <article class="wContent center" style="padding-top: 10px; padding-bottom: 20px;">
            <div class="mw-fast-list-box">
                <span class="mw-fast-list-sub" :class="{'fontBold fontRed': subNavTab == 0}" @click="changeNav(0)">最新</span>
                <span class="mw-fast-list-sub" style="margin: 0" :class="{'fontBold fontRed': subNavTab == item.sortId}" v-for="(item, index) in subNav_list" :key="index" @click="changeNav(item.sortId, item.sortName)">
                    <span v-if="reportClassify[item.sortName]" class="mw-fast-list-sub">{{ reportClassify[item.sortName] }}</span>
                </span>
            </div>

            <el-row :gutter="20" class="mw-modular-box">
                <el-col :span="16">
                    <div class="grid-content">
                        <div class="" style="margin-bottom: 15px;" v-show="adIDsIndex[0] && adIDsIndex[0]['list'].length > 0">
                            <a :href="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''" target="_blank">
                                <img :src="adIDsIndex[0] ? (adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: auto;" class="w100">
                            </a>
                        </div>
                        <div class="part-2 bgWhite">
                            <div class="part-tab">
                                <div class="part-tab-list">
                                    <div v-for="(item, index) in table_list" :key="index">

                                        <div class="part-tab-clist pointer" @click="goDetailPage(item.reportId)">
                                            <!-- <span class="tag">行业</span> -->
                                            <div style="flex: 1;">
                                                <img src="../../assets/images/report_fx_pz.png" alt srcset v-if="item.sortName == '唐宋100指数报告-分品种'"/>
                                                <img src="../../assets/images/report_fx.png" alt srcset v-else-if="item.sortName == '唐宋100指数（周）报告'" />
                                                <img src="../../assets/images/report_tejrb.png" alt srcset v-else-if="item.sortName == '唐尔街日报'" />
                                                <img src="../../assets/images/report_hysd.png" alt srcset v-else-if="item.sortName == '监测预警周报'" />
                                                <img src="../../assets/images/report_fx_pz.png" alt srcset v-else />
                                            </div>
                                            <div style="flex: 4;" class="w100 textLeft main"  >
                                                <h4 class="font16 fontBold fontNormal">{{ item.reportTitle }}</h4>
                                                <div class="main-sub fontLight" >{{ item.abstractText }}</div>
                                                <div class="main-tags-box">
                                                    <!--v-for="(table, tableI) in detailContent.sortName.split(',')" :key="tableI">{{ table == '唐宋100指数报告-分品种' || table == '唐宋100指数（周）报告' || table == '监测预警周报' || table == '唐尔街日报' ? reportClassify[table] : table }}-->
                                                    <span class="main-tag fontRed" v-for="(table, tableI) in item.sortName.split(',')" :key="tableI">{{ table == '唐宋100指数报告-分品种' || table == '唐宋100指数（周）报告' || table == '监测预警周报' || table == '唐尔街日报' ? reportClassify[table] : table }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mw-modular-box" v-show="sortName == '监测预警周报' && index == 3 && adIDsIndex[3] && adIDsIndex[3]['list'].length > 0">
                                            <a :href="adIDsIndex[3] ? ( adIDsIndex[3]['list'].length > 0 ? adIDsIndex[3]['list'][0]['adLink'] : '') : ''" target="_blank">
                                                <img :src="adIDsIndex[3] ? (adIDsIndex[3]['list'].length > 0 ? adIDsIndex[3]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 80px;" class="w100">
                                            </a>
                                        </div>
                                        <div class="mw-modular-box" v-show="sortName == '唐尔街日报' && index == 3 && adIDsIndex[4] && adIDsIndex[4]['list'].length > 0">
                                            <a :href="adIDsIndex[4] ? ( adIDsIndex[4]['list'].length > 0 ? adIDsIndex[4]['list'][0]['adLink'] : '') : ''" target="_blank">
                                                <img :src="adIDsIndex[4] ? (adIDsIndex[4]['list'].length > 0 ? adIDsIndex[4]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 80px;" class="w100">
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                        <div class="textCenter" style="padding-top: 30px">
                            <el-button class="load-more-btn" @click="loadMore()" v-show="isShowLoad">+ 加载更多</el-button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <FastNewsControl :ad="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''"></FastNewsControl>

                        <div v-if="adIDsIndex[5]['list']" style="margin-bottom: 20px;">
                            <a v-for="(item, index) in adIDsIndex[5]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: 20px">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>

                        <MapControl class="mw-modular-box"></MapControl>

                        <PriceIndexControl></PriceIndexControl>

                        <HotRecord style="margin-bottom: 0;" :ad="adIDsIndex[2] ? ( adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''"></HotRecord>
                    
                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import MapControl from '../../templates/mapControl'
import PriceIndexControl from '../../templates/priceIndexControl'
import FastNewsControl from '../../templates/fastNewsControl'
import HotRecord from '../../templates/hotRecord'
import { baseUrl, reportClassify, getQueryString, adIDs } from '../../assets/js/common'
export default {
    name: "Report",
    components: { MapControl, PriceIndexControl, FastNewsControl, HotRecord, ConcatsControl },
    data() {
        return {
            adIDsIndex: [],
            reportClassify: reportClassify,
            navigationId: '',
            subNav_list: [],
            subNavTab: 0,
            cPage: 1,
            pageSize: 12,
            isShowLoad: true,
            table_list: [],
            sortId: '',
            sortName: ''
        };
    },
    mounted() {
        // 初始化内容
        this.navigationId = this.$route.params.id;
        this.sortId = getQueryString('sortId');
        this.findReportSort();
        this.getAdByAdp();
    },
    methods: {
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'ybleft',
                id: adIDs['ybleft'],
                list: []
            },{
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            },{
                name: 'yb43',
                id: adIDs['yb43'],
                list: []
            },{
                name: 'yb42',
                id: adIDs['yb42'],
                list: []
            },{
                name: 'yb41',
                id: adIDs['yb41'],
                list: []
            },{
                name: 'yb49',
                id: adIDs['yb49'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },

        // 研报二级菜单
        findReportSort () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if (res.code == 0) {
                    self.subNav_list = res.data;
                    self.subNavTab = getQueryString('id') ? getQueryString('id') : 0;
                    self.searchReport();
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到分类信息')
            })
        },

        changeNav (id, name) {
            const self = this;
            self.sortId = '';
            self.sortName = name;
            self.subNavTab = id;
            self.table_list = [];
            self.cPage = 1;
            self.searchReport();
        },

        // 加载更多
        loadMore () {
            this.searchReport();
        },

        // 获取列表
        searchReport () {
            const self = this;
            self.$post(`${baseUrl.online}/industria/report/searchReport/${self.cPage}/${self.pageSize}`, {reportSort: self.sortId ? self.sortId : (self.subNavTab == 0 ? '' : self.subNavTab)}).then(res => {
                if (res.code == 0) {
                    if (res.data.length < 10) {
                        self.isShowLoad = false;
                    } else {
                        self.cPage += 1;
                    }
                    self.table_list = self.table_list.concat(res.data);
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('列表获取失败')
            })
        },

        goDetailPage (id) {
            this.$router.push(`/home/reportDetail/${id}`)
        }
    }
};
</script>

<style scoped>
@import url("report.css");
</style>